import { ILocation } from "lobbie";
import PatientSchedulingCard from "src/components/patients/scheduling/cards/PatientSchedulingCard";
import { TPatientSchedulingItem } from "src/components/patients/scheduling/types";
import { toAddressString } from "src/utils";
import SelectedCircle from "../../elements/icons/SelectedCircle";
import UnselectedCircle from "../../elements/icons/UnselectedCircle";

interface IProps {
    location: ILocation;
    selected: boolean;
    hideSelectCircle?: boolean;
    setSelected: (location: ILocation | null) => void;
    nextAvailable?: string;
    disabled?: boolean;
}

const SchedulingLocationCard: React.FC<IProps> = ({
    location,
    selected,
    hideSelectCircle,
    setSelected,
    disabled,
    nextAvailable,
}) => {
    const address = toAddressString(location.address);

    return (
        <PatientSchedulingCard
            item={location}
            selected={selected}
            setSelected={setSelected as (item: TPatientSchedulingItem | null) => void}
            disabled={disabled}
        >
            <div className="row align-items-center">
                {/* {location.branding && (
                    <div className="col-3 text-center">
                        <SchedulingBrandingLogo
                            branding={location.branding}
                        />
                    </div>
                )} */}
                {/* <div className={`col-${location.branding ? 7 : "10 text-left"}`}> */}
                <div className={"col-10 text-left"}>
                    <div className={`body-medium bold ${disabled ? "gray3" : "blue"}`}>
                        {location.name}
                    </div>
                    {nextAvailable && (
                        <div className={disabled ? "gray3 body-small mt-1" : "body-small mt-1"}>
                            {nextAvailable}
                        </div>
                    )}

                    <div className={disabled ? "gray3 body-small mt-1" : "body-small mt-1"}>
                        {address}
                    </div>
                </div>
                {!hideSelectCircle && (
                    <div className="col-2 text-right">
                        {selected ? <SelectedCircle disabled={disabled} /> : <UnselectedCircle />}
                    </div>
                )}
            </div>
        </PatientSchedulingCard>
    );
};

export default SchedulingLocationCard;
